import { firestore } from "../../config/firebase";
import { addDoc, collection } from "firebase/firestore";

const createInvestmentPromoCode = async (obj) => {
  const investmentPromoCollection = collection(firestore, "investmentPromos");
  try{
    await addDoc(investmentPromoCollection, obj);
    console.log("done");
  }catch(e){
    console.error("Cannot create promo code: ", e)
  }
};

export default createInvestmentPromoCode;
